<template>
    <v-card flat class="mb-3">
        <div>
            <v-layout row wrap>
                <v-flex xs12 lg8 offset-lg2>
                    <v-card flat class="mt-3 pa-1" v-if="inputData">
                        <v-form ref="form">
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-text-field
                                            class="pa-3"
                                            v-model="name"
                                            label="Lietotājvārds"
                                            color="deep-purple accent-3"
                                            :rules="formRules"
                                            required>
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 md6>
                                    <v-text-field
                                            class="pa-3"
                                            v-model="email"
                                            label="E-pasts"
                                            color="deep-purple accent-3"
                                            :rules="formRules"
                                            :error-messages="errorMessages.email"
                                            required
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 md6>
                                    <v-text-field
                                            class="pa-3"
                                            v-model="password"
                                            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            @click:append="showPassword = !showPassword"
                                            label="Parole"
                                            color="deep-purple accent-3"
                                            :error-messages="errorMessages.password"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 md6>
                                    <v-select
                                            class="pa-3"
                                            v-model="role"
                                            color="deep-purple accent-3"
                                            :rules="formRules"
                                            item-text="display_name"
                                            item-value="id"
                                            :items="inputData.roles"
                                            label="Loma"
                                        />
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 class="mx-3 mb-3">
                                    <div class="text-xs-center text-md-right">
                                        <v-btn small flat @click="hideAddUserForm" dark color="deep-orange lighten-1">
                                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                                            <v-icon dark right>check_circle</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>

        </div>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "add-user",
        data: () => ({
            showPassword: false,
            name: '',
            email: '',
            password: '',
            role: 2,
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        mounted() {
            this.$store.dispatch('getUserInputData')
        },
        computed: {
            ...mapGetters({
                inputData: 'userInputData',
                errorMessages: 'userErrorMessages'
            })
        },
        methods: {
            hideAddUserForm(){
                this.$store.dispatch('clearUserErrorMessages')
                this.$store.dispatch('hideAddUserForm')
            },
            submit(){
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewUser', {
                        name: this.name,
                        password: this.password,
                        email: this.email,
                        roleId: this.role,
                    })
                }  else {
                    this.$Progress.fail()
                }
            },
        }
    }
</script>

<style scoped>

</style>